import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ConfirmationDialogComponent } from 'src/app/components/shared-components/confirmation-dialog/confirmation-dialog.component';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';
import { CenterDeleteImpact, CenterDeleteImpactItem } from 'src/app/models/center-model/center-delete-impact.model';

@Component({
  selector: 'app-centers-center-resume-card',
  templateUrl: './centers-center-resume-card.component.html',
  styleUrls: ['./centers-center-resume-card.component.scss']
})
export class CentersCenterResumeCardComponent implements OnInit, OnDestroy {

  @Input() center;
  @Input() viewDisposition;
  deleting = false;
  private impactSubscription: Subscription;
  private confirmationSubscription: Subscription;
  private deleteSubscription: Subscription;

  constructor(private router: Router,
              private centersService: CentersCentersService,
              private dialog: MatDialog,
              private snackbar: SnackBarService,
              private translate: TranslateService) { }

  ngOnInit() { }

  public gotoDetails(e) {
    if ((e.target.className !== 'mat-icon notranslate material-icons mat-icon-no-color') && (e.target.className !== 'mat-icon-button') && (e.target.tagName !== 'SPAN')) {
      this.router.navigate(['/center', this.center.InternalId]);
    }
  }

  public deleteCenter(event: MouseEvent) {
    event.stopPropagation();
    if (this.deleting || !this.center) { return; }
    this.deleting = true;
    this.impactSubscription = this.centersService.getCenterDeleteImpact(this.center.InternalId).subscribe(
      (impact: CenterDeleteImpact) => {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          data: {
            title: 'stores-page.delete center title',
            messages: ['stores-page.delete center warning'],
            messageParams: { name: impact.centerName || this.center.CenterName },
            requiredWordKey: 'stores-page.delete center keyword',
            requiredWordPromptKey: 'stores-page.delete center prompt',
            confirmLabel: 'stores-page.delete center action',
            detailsTitle: 'stores-page.delete center impact title',
            detailsEmpty: 'stores-page.delete center impact empty',
            details: impact.impactList.map(item => this.impactDetail(item))
          }
        });
        this.confirmationSubscription = dialogRef.afterClosed().subscribe(confirmed => {
          if (!confirmed) { this.deleting = false; return; }
          this.deleteSubscription = this.centersService.deleteCenter(this.center.InternalId).subscribe(
            () => {
              this.deleting = false;
              this.snackbar.open(this.translate.instant('stores-page.delete center success'), 'success');
            },
            error => { this.deleting = false; this.showError(error); }
          );
        });
      },
      error => { this.deleting = false; this.showError(error, 'stores-page.delete center impact failed'); }
    );
  }

  private impactDetail(item: CenterDeleteImpactItem) {
    const typeKeys = {
      SMS: 'stores-page.delete center impact SMS',
      TICKET: 'stores-page.delete center impact TICKET',
      CALENDAR: 'stores-page.delete center impact CALENDAR'
    };
    let message = 'stores-page.delete center impact other';
    if (item.impactType === 'OWNER_SHARED' && item.resourceType === 'CALENDAR') {
      message = 'stores-page.delete center impact calendar shared';
    } else if (item.impactType === 'OWNER_SHARED' && (item.resourceType === 'SMS' || item.resourceType === 'TICKET')) {
      message = 'stores-page.delete center impact cascade';
    }
    return {
      name: item.name || item.internalId,
      type: typeKeys[item.resourceType] || item.resourceType,
      message,
      params: { centers: item.affectedCenters, desks: item.affectedDesks }
    };
  }

  private showError(error: any, fallbackKey = 'stores-page.delete center failed') {
    const rawMessage = error && error.error && error.error.message || error && error.message;
    const message = typeof rawMessage === 'string' && rawMessage ? rawMessage : fallbackKey;
    this.snackbar.open(message.indexOf('stores-page.') === 0 ? this.translate.instant(message) : message, 'error');
  }

  ngOnDestroy() {
    if (this.impactSubscription) { this.impactSubscription.unsubscribe(); }
    if (this.confirmationSubscription) { this.confirmationSubscription.unsubscribe(); }
    if (this.deleteSubscription) { this.deleteSubscription.unsubscribe(); }
  }

}
